import { TooltipProps } from 'recharts';
import { Button, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { EnumCurrency } from 'tdc-web-backend/enums/enums';
import { IGraphMilestone } from '../../interface';
import { formatCurrency } from '../../../../../../utils/helpers';

const ChartTooltip = ({ payload, label, active }: TooltipProps<number, string>) => {
  if (payload && active && payload.length) {
    const date = new Date(label);
    const payloadItem = payload[0].payload as IGraphMilestone;

    return (
      <Button sx={{ py: 2, opacity: 1 }} size="small" variant="contained">
        <Stack spacing={3} alignItems="start" justifyContent="space-between">
          {/* current date */}
          <Stack spacing={1} alignItems="start">
            <Typography component="span" fontWeight="600" color="grey.300">
              {format(date, 'MMM d, yyyy')}
            </Typography>
          </Stack>

          {/* paid milestones */}
          {payloadItem.paidMilestonesEur.length > 0 && (
            <Stack alignItems="start">
              <Stack alignItems="start">
                <Typography component="span" variant="bodyMedium2" fontWeight="600">
                  {payloadItem.paidMilestonesEur.length > 1 ? 'Paid Milestones' : 'Paid Milestone'}{' '}
                  (€):
                </Typography>

                <Stack>
                  {payloadItem.paidMilestonesEur.map((name) => (
                    <Typography key={name}> {name}</Typography>
                  ))}
                </Stack>
              </Stack>

              {payloadItem.paidEur !== 0 && (
                <Typography>
                  Payment:{' '}
                  <Typography component="span" variant="bodySemiBold2">
                    {formatCurrency(payloadItem.paidEur, EnumCurrency.Eur)}
                  </Typography>
                </Typography>
              )}
            </Stack>
          )}

          {payloadItem.paidMilestonesUsd.length > 0 && (
            <Stack alignItems="start">
              <Stack alignItems="start">
                <Typography component="span" fontWeight="600">
                  {payloadItem.paidMilestonesUsd.length > 1 ? 'Paid Milestones' : 'Paid Milestone'}{' '}
                  ($):
                </Typography>

                <Stack alignItems="start">
                  {payloadItem.paidMilestonesUsd.map((name) => (
                    <Typography key={name}>{name}</Typography>
                  ))}
                </Stack>
              </Stack>

              {payloadItem.paidUsd !== 0 && (
                <Typography>
                  Payment:{' '}
                  <Typography component="span" variant="bodySemiBold2">
                    {formatCurrency(payloadItem.paidUsd, EnumCurrency.Usd)}
                  </Typography>
                </Typography>
              )}
            </Stack>
          )}

          {/* unpaid milestones */}
          {payloadItem.unpaidMilestonesEur.length > 0 && (
            <Stack alignItems="start">
              <Stack alignItems="start">
                <Typography component="span" fontWeight="600" alignItems="start">
                  {payloadItem.unpaidMilestonesEur.length > 1
                    ? 'Unpaid Milestones'
                    : 'Unapide Milestone'}{' '}
                  (€):
                </Typography>

                <Stack alignItems="start">
                  {payloadItem.unpaidMilestonesEur.map((name) => (
                    <Typography key={name}>{name}</Typography>
                  ))}
                </Stack>
              </Stack>

              {payloadItem.unpaidEur !== 0 && (
                <Typography>
                  Expected payment:{' '}
                  <Typography component="span" variant="bodySemiBold2">
                    {formatCurrency(payloadItem.unpaidEur, EnumCurrency.Eur)}
                  </Typography>
                </Typography>
              )}
            </Stack>
          )}
          {payloadItem.unpaidMilestonesUsd.length > 0 && (
            <Stack alignItems="start">
              <Stack alignItems="start">
                <Typography component="span" fontWeight="600" alignItems="start">
                  {payloadItem.unpaidMilestonesUsd.length > 1
                    ? 'Unpaid Milestones'
                    : 'Unapide Milestone'}{' '}
                  ($):
                </Typography>

                <Stack alignItems="start">
                  {payloadItem.unpaidMilestonesUsd.map((name) => (
                    <Typography key={name}>{name}</Typography>
                  ))}
                </Stack>
              </Stack>

              {payloadItem.unpaidUsd !== 0 && (
                <Typography>
                  Expected payment:{' '}
                  <Typography component="span" variant="bodySemiBold2">
                    {formatCurrency(payloadItem.unpaidEur, EnumCurrency.Usd)}
                  </Typography>
                </Typography>
              )}
            </Stack>
          )}
        </Stack>
      </Button>
    );
  }

  return null;
};

export default ChartTooltip;
